export const BLANK_VIDEO_DURATION = 10000;
export const BLANK_VIDEO_SRC =
  "4c8326fb598f1b37b97052fd2ff7cefa49804da3/rmhsdqioi1qggkxs";
